import { actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
  } from './../../../actions/utilAction';
  export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
    API_URL,
  };

  export const GETALL_ERA_CLAIMS = `${API_URL}/api/ManageERA/GetAllManageERA`;
  export const GET_EDI_GATEWAYS = `${API_URL}/EDIGateways/GetEDIGateways`;
  export const GET_EDI835_FILE_API = `${API_URL}/EDIParser/GetEDI835File`;
  export const BULK_DOWNLOAD_ERA_DETAILS =  `${API_URL}/api/ManageERA/AllManageERAExportAsXLS` ;

export const ManageERAActionTypes = {
    get_All_ERA_Claims:createRequestActionTypes('GETALL_ERA_CLAIMS'),
    get_EDI_GateWays:createRequestActionTypes('GET_EDI_GATEWAYS'),
    get_EDI835_File:createRequestActionTypes('GET_EDI835_FILE_API'),
    bULK_DOWNLOAD_ERA_DETAILS:createRequestActionTypes('BULK_DOWNLOAD_ERA_DETAILS'),
};

export const MODULE = 'MANAGEERA'


// WEBPACK FOOTER //
// ./src/modules/ManageERA/constants/ApiConstants.js